import React, { useContext, useMemo } from 'react';
import { useTheme } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import Styles from '../Menu/Menu.module.scss';
import { MenuIcons, CustomMenuIcons } from '../Menu/MenuIcons';
import ROW2Mapping from '../Menu/ROW2Mapping';
import { DraggedMenuItemContext } from '../Menu/Menu';
import { DobButton } from '@dedalusdiit/dob-components';
import { MenuItemProps } from '@/Models/MenuItemProps';
import { handleMenuItemClick } from '@/Routes/Helper/MenuItemHandler';

function MenuListItemLink(props: Readonly<MenuItemProps>): React.ReactElement {
    const theme = useTheme();
    const navigate = useNavigate();
    const { icon, primary, to, sub, full, addToFavorites } = props;
    const Comp = MenuIcons[icon as keyof React.ElementType] ?? (theme.palette.mode === 'dark' ? CustomMenuIcons[icon as keyof React.ElementType] : CustomMenuIcons[icon + 'Black' as keyof React.ElementType]);
    const { set: setDragged } = useContext(DraggedMenuItemContext);
    const fullTo = useMemo(() => {
        if (full.Parameters === null || full.Parameters === '') {
            return to;
        }
        return `${to}?${full.Parameters}`;
    }, [full, to]);

    const dragStart = (): void => {
        setDragged(full);
    };

    const openExternal = (e: React.MouseEvent): void => {
        e.stopPropagation();
        e.preventDefault();
        window.open(window.location.origin + ROW2Mapping[to], '_blank');
    };

    return (
        <Link to={fullTo} className={sub ? Styles.subNav + ' ' + Styles.navItem : ('nav ' + Styles.navItem)} onDragStart={dragStart} onClick={(e) => {
            void handleMenuItemClick(navigate, fullTo, e); 
        }}>
            <div className={Styles.navIconAndText}>
                { Comp && <div className={Styles.navIcon}>{Comp}</div> }
                <div className={Styles.navText}>{primary}</div>
            </div>
            <div className={Styles.navButtons}>
                { full.ExternalLink && <DobButton size="small" color="silent" onClick={openExternal} icon="box-arrow-up-right" /> }
                <DobButton
                    size="small"
                    color="silent"
                    onClick={(e) => addToFavorites?.(e, full)}
                    icon={full.InFavorites ? 'star-fill' : 'star'}
                />
            </div>
        </Link>
    );
}

export default MenuListItemLink;
